


















import {Component, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import ReportViewerContainer
  from '@/modules/neodash/components/report-viewer-container/report-viewer-container.vue';
import PeriodForm from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';
import {ConstantsVirtualArea} from '@/modules/neodash/model/constants/locationType';
import {NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {ReportsReportViewerEnum} from '../../model/types/enums/reportsReportViewerEnum';
import {getUrlReportViewer} from '@/modules/neodash/model/constants/reportViewer';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {VirtualAreasEnum} from '@/modules/neodash/model/types/enums/virtualAreasEnum';
import {GET_PERIOD} from '@/modules/neodash/store/modules/reports/types';
import {Getter} from 'vuex-class';
import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

interface localeType {
  id: VirtualAreasEnum,
  report: ReportsReportViewerEnum
}

@Component({
  name: 'MarketAnalysisProduct',
  components: {
    ReportContainer,
    FilterContainer,
    ReportViewerContainer,
    PeriodForm,
    FilterDropDown
  }
})
export default class MarketAnalysisProduct extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  private readonly typeAreas: localeType[] = [
    {id: VirtualAreasEnum.MitsubishiActingArea, report: ReportsReportViewerEnum.MarketAnalysisProductsActingArea},
    {
      id: VirtualAreasEnum.MitsubishiOperationalAreas,
      report: ReportsReportViewerEnum.MarketAnalysisProductsOperational
    }
  ];

  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  public url: string = '';
  public labelFilters: IKeyValues = [];

  public chosenVirtualArea: OptionalNameValue = null;
  public period: PeriodFormValue = null;

  public get limits(): Period {
    setTimeout(() => { }, 300);
    return this.getPeriod(ReportEnum.MarketAnalysisByProduct);
  }

  public get localeTypes(): NameValues {
    return this.typeAreas.map(x => ({
      name: ConstantsVirtualArea.getNameVirtualArea(x.id),
      value: x.id
    }));
  }

  public updateLabelFilters(): void {
    const {chosenVirtualArea, translate, period} = this;
    if (!chosenVirtualArea || !period)
      return;

    this.labelFilters = [
      {text: translate('Common.LocaleType'), value: chosenVirtualArea.name},
      {text: translate('Common.Period'), value: period.label}
    ]
  }

  public get formValid(): boolean {
    return !!this.chosenVirtualArea && !!this.chosenVirtualArea.value;
  }

  public showReport(): void {
    const {period, chosenVirtualArea, typeAreas} = this;
    if (!period || !chosenVirtualArea)
      return;

    const report = typeAreas.findOrFirst(x => x.id === chosenVirtualArea.value).report;

    traceLogAccess.logAction(ContextEnum.Report, 'Análise de Mercado por Produto - Filtro', JSON.stringify(period));
    this.url = getUrlReportViewer(report, {...period.value});
    this.updateLabelFilters();
  }
}
